import { BACKEND_API_URL, STRIPE_PORTAL_URL } from '../env';

/* Functions for fetching data from the api. In the future should be refactored to use reactQuery or similar, also including authentication. */
async function fetchData(url, method, body) {
    const headers = {
        "Content-Type": "application/json"
    }
    let response;
    if (method === "GET") {
        response = await fetch(url, {
            method,
            headers,
            credentials: "include"
        });
    } else {
        response = await fetch(url, {
            method,
            headers,
            body: JSON.stringify(body),
            credentials: "include"
        });
    }
    return response;
}

export const getLogOut = async () => {
    const response = await fetchData(`${BACKEND_API_URL}/api/logout/`, "POST");
    return response;
}

export const getAuthenticatedUser = async () => {
    const response = await fetchData(`${BACKEND_API_URL}/api/authenticated-user/`, "GET");
    return response;
}

export const refreshToken = async () => {
    const response = await fetchData(`${BACKEND_API_URL}/api/token/refresh/`, "POST");
    return response;
}

export const getInstruments = async () => {
    const response = await fetchData(`${BACKEND_API_URL}/api/instruments/`, "GET");
    return response;
}
export const redirectTologin = () => {
    window.location.href = `${BACKEND_API_URL}/login/`;
}

export const create_checkout_session = async (price_id, mode="subscription") => {
    const headers = {"Content-Type": "application/json"}
    const body = {"price_id": price_id, "mode": mode};

    await fetch(`${BACKEND_API_URL}/api/stripe/create-checkout-session/`, { 
        method: "POST", 
        headers,
        body: JSON.stringify(body),
        credentials: "include"
    }) 
    .then(response => {
        return response.json();
    })
    .then(data => {
        // console.log(data)
        if(data.url !== undefined) {
            window.location.href = data.url;
        } else {
            // console.log("is undefined")
            // window.open('https://billing.stripe.com/p/login/test_28o28u6xkb1sgggeUU', '_blank')
            window.location.href = STRIPE_PORTAL_URL;
        }
    })
    .catch(error => {
        console.error('Error retrieving data:', error);
    });
}